import { HttpErrorResponse } from '@angular/common/http';

export type ChatErrorLogContext = {
  httpStatus?: number;
  url?: string;
  errorName?: string;
  errorMessage?: string;
};

/**
 * Loggable fields for an error; never includes the response body or headers. An HTTP error's name and message
 * only restate its status and url, so they are omitted.
 */
export function getChatErrorLogContext(error: unknown): ChatErrorLogContext {
  if (error instanceof HttpErrorResponse) {
    return {
      httpStatus: error.status,
      url: error.url ?? undefined
    };
  }

  if (error instanceof Error) {
    return { errorName: error.name, errorMessage: error.message };
  }

  return { errorName: typeof error, errorMessage: String(error) };
}
